import FormattedMessage from 'I18n/components/FormattedMessage';
import { ONBOARDING_CMS_FREE, ONBOARDING_STARTER_CMS, ONBOARDING_INVITED_CMS } from 'getting-started-shared-tasks/onboardingKeys';
import { CMS_ACADEMY_URL, CMS_SOLUTION_MARKETPLACE_URL } from '../constants/urls';
import { LEARN_MORE_CTAS } from '../constants/enums';
import { getDefaultCmsTaskGroupOverrides } from '../constants/defaultTaskGroupOverrides';
import { jsx as _jsx } from "react/jsx-runtime";
export default function getCmsViewConfig(__appContexts) {
  return {
    [ONBOARDING_CMS_FREE]: {
      taskGroupOverrides: getDefaultCmsTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cms.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_CMS,
          href: CMS_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cms.learnMore.ctas.academy-cms"
          }),
          icon: 'website',
          external: true
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_CMS,
          href: CMS_SOLUTION_MARKETPLACE_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cms.learnMore.ctas.marketplace-cms"
          }),
          icon: 'marketplace',
          external: true
        }]
      }
    },
    [ONBOARDING_INVITED_CMS]: {
      taskGroupOverrides: getDefaultCmsTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cms.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_CMS,
          href: CMS_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cms.learnMore.ctas.academy-cms"
          }),
          icon: 'website',
          external: true
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_CMS,
          href: CMS_SOLUTION_MARKETPLACE_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cms.learnMore.ctas.marketplace-cms"
          }),
          icon: 'marketplace',
          external: true
        }]
      }
    },
    [ONBOARDING_STARTER_CMS]: {
      taskGroupOverrides: getDefaultCmsTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cms.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_CMS,
          href: CMS_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cms.learnMore.ctas.academy-cms"
          }),
          icon: 'website',
          external: true
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_CMS,
          href: CMS_SOLUTION_MARKETPLACE_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cms.learnMore.ctas.marketplace-cms"
          }),
          icon: 'marketplace',
          external: true
        }]
      }
    }
  };
}